import gql from 'graphql-tag';

export const updateRoleAssignmentsMutation = gql`
  mutation updateRoleAssignments($resourceId: String!, $resourceType: String!, $assignmentIdsToDelete: [String], $assignmentsToUpsert: [RoleAssignmentInput!]) {
    updateRoleAssignments(resourceId: $resourceId, resourceType: $resourceType, assignmentIdsToDelete: $assignmentIdsToDelete, assignmentsToUpsert: $assignmentsToUpsert) {
      user {
        userId
        firstName
        lastName
        imageUrl
        email
      }
      team {
        teamId
        name
        imageUrl
        members {
          teamMembershipId
        }
      }
      organisation {
        organisationId
      }
      role {
        roleId
        name
      }
      canSearch
      public
      isPrivate
      password
      resourceRoleAssignmentId
    }
  }
`;

const updateRoleAssignments = () => ({
  mutation: updateRoleAssignmentsMutation,
  module: 'users',
  buildVariables: (
  {
    resourceId,
    resourceType,
    assignmentIdsToDelete,
    assignmentsToUpsert





  }) => (
  {
    resourceId,
    resourceType,
    assignmentIdsToDelete,
    assignmentsToUpsert
  })
});

export default updateRoleAssignments;